
import katex_1 from "katex";
import { generateLabel } from "../../DrawBlock/SymbolUpdate.js";
import { NumberBase, Connection_$reflection, Component_$reflection, Component, Connection, Port, PortType, ComponentType } from "../../Common/CommonTypes.js";
import { SimSubTab, TTMsg, Msg } from "../../Model/ModelType.js";
import { choose, mapIndexed, concat, zip, mapFold, cons, exists, length, item, tryFindIndex, filter as filter_1, collect, singleton, tail, head, isEmpty, map, contains, empty, ofArray, append, fold, iterate } from "../../fable_modules/fable-library-js.5.13.0/List.js";
import { toFail, printf, toText } from "../../fable_modules/fable-library-js.5.13.0/String.js";
import { setComponentLabel } from "../MenuHelpers.js";
import { DrawModelType_SheetT_Model__Model_get_GetSelectedCanvasState, DrawModelType_SheetT_Model__Model_GetCanvasState } from "../../DrawBlock/Sheet.js";
import { defaultOf, createAtom, comparePrimitives, stringHash, int32ToString, compare, safeHash, equals } from "../../fable_modules/fable-library-js.5.13.0/Util.js";
import { inferConnectionsWidth } from "../../Common/WidthInferer.js";
import { FSharpResult$2 } from "../../fable_modules/fable-library-js.5.13.0/Result.js";
import { FSharpMap__get_IsEmpty, empty as empty_1, FSharpMap__get_Item, tryFind, toList, ofList } from "../../fable_modules/fable-library-js.5.13.0/Map.js";
import { defaultArg, value as value_3 } from "../../fable_modules/fable-library-js.5.13.0/Option.js";
import { analyseState, portNames } from "../../Simulator/CanvasStateAnalyser.js";
import { IdAllocator_newPortId, IdAllocator_newComponentId, IdAllocator_newConnectionId } from "../../Common/Helpers.js";
import { SimGraph_toList, errMsg, expToKatex, SimulationError_$reflection, SimulationError, SimulationErrorType } from "../../Simulator/SimGraphTypes.js";
import { List_distinct } from "../../fable_modules/fable-library-js.5.13.0/Seq2.js";
import { Union, toString, Record } from "../../fable_modules/fable-library-js.5.13.0/Types.js";
import { int32_type, record_type, union_type, tuple_type, list_type } from "../../fable_modules/fable-library-js.5.13.0/Reflection.js";
import { SimulationData, SimulationData_$reflection } from "../../Simulator/SimTypes.js";
import { simulationPlaceholder } from "../../Simulator/FastSim/FastCreate.js";
import { stateIsEqual } from "../../Simulator/CanvasExtractor.js";
import { startCircuitSimulationFData } from "../../Simulator/Simulator.js";
import { Option, button } from "../../fable_modules/Fulma.3.0.0/Elements/Button.fs.js";
import { empty as empty_2, singleton as singleton_1, append as append_1, delay, toList as toList_1 } from "../../fable_modules/fable-library-js.5.13.0/Seq.js";
import { rightSectionWidth, ttGridContainerStyle, menuLabelStyle, colMoveArrowStyle, sortArrowStyle } from "../Style.js";
import { Color_IColor } from "../../fable_modules/Fulma.3.0.0/Common.fs.js";
import { Constants_maxTruthTableBusWidth, CellIO__get_getLabel, MoveDirection, SortType } from "../../Simulator/TruthTableTypes.js";
import * as react from "react";
import { viewConstraints, viewReductions, addToolTipTop, makeOnOffToggle, makeElementLine } from "./ConstraintReduceView.js";
import { keyValueList } from "../../fable_modules/fable-library-js.5.13.0/MapUtil.js";
import { menu as menu_1, list as list_17 } from "../../fable_modules/Fulma.3.0.0/Components/Menu.fs.js";
import { DangerousHtml, DOMAttr, HTMLAttr, CSSProp } from "../../fable_modules/Fable.React.9.4.0/Fable.React.Props.fs.js";
import { convertWireDataToInt, bitToString } from "../../Simulator/NumberHelpers.js";
import { viewFilledNum } from "../MemoryEditorView.js";
import { Option as Option_1, h5 } from "../../fable_modules/Fulma.3.0.0/Elements/Heading.fs.js";
import { simulateModel } from "../ModelHelpers.js";
import { viewSimulationError, setSimErrorFeedback } from "../SimulationView.js";
import { couldBeSynchronousComponent, hasSynchronousComponents } from "../../Simulator/SynchronousUtils.js";
import { TruthTable_notCombinational, TruthTable_busTooWide } from "../../Common/AppMessages.js";
import { errorPropsNotification } from "../Notifications.js";
import { Option as Option_2, notification } from "../../fable_modules/Fulma.3.0.0/Elements/Notification.fs.js";
import { DrawModelType_SheetT_Msg } from "../../Model/DrawModelType.js";

export const katex = katex_1;

/**
 * Updates MergeWires and SplitWire Component labels to MWx/SWx.
 * Previous Issie versions had empty labels for these components.
 */
export function updateMergeSplitWireLabels(model, dispatch) {
    let value, value_1;
    const symModel = model.Sheet.Wire.Symbol;
    const mwStartLabel = generateLabel(symModel, ComponentType.MergeWires);
    let mwIdx = ((value = mwStartLabel[mwStartLabel.length - 1], ~~value.charCodeAt(0))) - ~~"0".charCodeAt(0);
    const swStartLabel = generateLabel(symModel, new ComponentType(/* SplitWire */ 28, [1]));
    let swIdx = ((value_1 = swStartLabel[swStartLabel.length - 1], ~~value_1.charCodeAt(0))) - ~~"0".charCodeAt(0);
    const sheetDispatch = (sMsg) => {
        dispatch(new Msg(/* Sheet */ 3, [sMsg]));
    };
    iterate((c) => {
        const matchValue = c.Type;
        const matchValue_1 = c.Label;
        let matchResult;
        switch (matchValue.tag) {
            case 27: {
                switch (matchValue_1) {
                    case "":
                    case "L": {
                        matchResult = 0;
                        break;
                    }
                    default:
                        matchResult = 2;
                }
                break;
            }
            case 28: {
                switch (matchValue_1) {
                    case "":
                    case "L": {
                        matchResult = 1;
                        break;
                    }
                    default:
                        matchResult = 2;
                }
                break;
            }
            default:
                matchResult = 2;
        }
        switch (matchResult) {
            case 0: {
                let newLabel;
                const arg = mwIdx | 0;
                newLabel = toText(printf("MW%i"))(arg);
                mwIdx = ((mwIdx + 1) | 0);
                setComponentLabel(model, sheetDispatch, c, newLabel);
                break;
            }
            case 1: {
                let newLabel_1;
                const arg_1 = swIdx | 0;
                newLabel_1 = toText(printf("SW%i"))(arg_1);
                swIdx = ((swIdx + 1) | 0);
                setComponentLabel(model, sheetDispatch, c, newLabel_1);
                break;
            }
            case 2: {
                break;
            }
        }
    }, DrawModelType_SheetT_Model__Model_GetCanvasState(model.Sheet)[0]);
}

/**
 * From a Connection Id and a list of all Connections, return the Ids for the source
 * and target ports of Connection described by the Connection Id.
 */
export function getPortIdsfromConnectionId(cid, conns) {
    return fold((pIds, c) => {
        if (equals(c.Id, cid)) {
            return append(pIds, ofArray([c.Source.Id, c.Target.Id]));
        }
        else {
            return pIds;
        }
    }, empty(), conns);
}

/**
 * Returns true if the provided port is present in any of the connections in the
 * Connection list.
 */
export function isPortInConnections(port, conns) {
    return fold((b, c) => {
        if (equals(port.Id, c.Source.Id) ? true : equals(port.Id, c.Target.Id)) {
            return true;
        }
        else {
            return b;
        }
    }, false, conns);
}

/**
 * Returns true if the provided port is present in any of the components in the
 * Component list.
 */
export function isPortInComponents(port, comps) {
    return fold((b, c) => {
        if (contains(port.Id, map((p) => p.Id, append(c.InputPorts, c.OutputPorts)), {
            Equals: equals,
            GetHashCode: (x) => (safeHash(x) | 0),
        })) {
            return true;
        }
        else {
            return b;
        }
    }, false, comps);
}

/**
 * Partitions a list of results into a list of Ok and list of Error
 */
export function partitionResults(results) {
    const filter = (lst_mut, success_mut, error_mut) => {
        filter:
        while (true) {
            const lst = lst_mut, success = success_mut, error = error_mut;
            if (!isEmpty(lst)) {
                const copyOfStruct = head(lst);
                if (copyOfStruct.tag === 1) {
                    lst_mut = tail(lst);
                    success_mut = success;
                    error_mut = append(error, singleton(copyOfStruct.fields[0]));
                    continue filter;
                }
                else {
                    lst_mut = tail(lst);
                    success_mut = append(success, singleton(copyOfStruct.fields[0]));
                    error_mut = error;
                    continue filter;
                }
            }
            else {
                return [success, error];
            }
            break;
        }
    };
    return filter(results, empty(), empty());
}

/**
 * Fills in internal connections between any two selected components.
 * This makes a contiguous circuit. This allows truth tables to be selected via comnponents only.
 */
export function addInternalConnections(_arg2_, _arg2__1, _arg1_, _arg1__1) {
    const _arg = [_arg2_, _arg2__1];
    const conns = _arg[1];
    const comps = _arg[0];
    const circuitPorts = map((port) => port.Id, collect((comp) => append(comp.InputPorts, comp.OutputPorts), comps));
    return [comps, append(filter_1((conn) => {
        if (!contains(conn, conns, {
            Equals: equals,
            GetHashCode: (x) => (safeHash(x) | 0),
        }) && contains(conn.Source.Id, circuitPorts, {
            Equals: equals,
            GetHashCode: (x_1) => (safeHash(x_1) | 0),
        })) {
            return contains(conn.Target.Id, circuitPorts, {
                Equals: equals,
                GetHashCode: (x_2) => (safeHash(x_2) | 0),
            });
        }
        else {
            return false;
        }
    }, _arg1__1), conns)];
}

/**
 * Corrects the Selected Canvas State by adding extra connections and IOs to components
 * not connected to anything. On success returns a new, corrected CanvasState compatible
 * with Step Simulator. On failure returns SimulationError.
 */
export function correctCanvasState(selectedCanvasState_, selectedCanvasState__1, wholeCanvasState_, wholeCanvasState__1) {
    const selectedCanvasState = [selectedCanvasState_, selectedCanvasState__1];
    const wholeCanvasState = [wholeCanvasState_, wholeCanvasState__1];
    const patternInput = addInternalConnections(selectedCanvasState[0], selectedCanvasState[1], wholeCanvasState[0], wholeCanvasState[1]);
    const components = patternInput[0];
    const dummyInputPort = new Port(-1, undefined, PortType.Input, -2);
    const dummyOutputPort = new Port(-3, undefined, PortType.Output, -4);
    let portWidths;
    const matchValue = inferConnectionsWidth(wholeCanvasState[0], wholeCanvasState[1]);
    portWidths = ((matchValue.tag === 1) ? (new FSharpResult$2(/* Error */ 1, [matchValue.fields[0]])) : (new FSharpResult$2(/* Ok */ 0, [ofList(fold((acc, tupledArg) => append(acc, map((pId) => [pId, tupledArg[1]], getPortIdsfromConnectionId(tupledArg[0], wholeCanvasState[1]))), empty(), toList(matchValue.fields[0])), {
        Compare: (x, y) => (compare(x, y) | 0),
    })])));
    const getPortWidth$0027 = (port) => ((pw) => ((run) => {
        let w;
        const matchValue_1 = tryFind(port.Id, pw);
        return (matchValue_1 == null) ? getPortWidthFromComponent(port)(pw)(run) : ((value_3(matchValue_1) == null) ? toFail(printf("what? WidthInferrer did not infer a width for a port")) : ((w = (value_3(matchValue_1) | 0), w)));
    }));
    const getPortWidthFromComponent = (port_1) => ((pw_1) => ((run_1) => {
        let hostComponent;
        const _arg = filter_1((c) => equals(port_1.HostId, c.Id), components);
        hostComponent = (isEmpty(_arg) ? toFail(printf("what? Port HostId does not match any ComponentIds in model")) : (isEmpty(tail(_arg)) ? head(_arg) : toFail(printf("what? Port HostId matches multiple ComponentIds in model"))));
        const matchValue_2 = hostComponent.Type;
        let matchResult, w_1;
        switch (matchValue_2.tag) {
            case 8:
            case 10: {
                matchResult = 0;
                break;
            }
            case 3: {
                matchResult = 2;
                break;
            }
            case 26: {
                matchResult = 3;
                break;
            }
            case 48: {
                matchResult = 1;
                w_1 = matchValue_2.fields[0];
                break;
            }
            case 1: {
                matchResult = 1;
                w_1 = matchValue_2.fields[0];
                break;
            }
            case 49: {
                matchResult = 1;
                w_1 = matchValue_2.fields[0];
                break;
            }
            case 47: {
                matchResult = 1;
                w_1 = matchValue_2.fields[0];
                break;
            }
            case 6: {
                matchResult = 1;
                w_1 = matchValue_2.fields[0];
                break;
            }
            case 17: {
                matchResult = 1;
                w_1 = matchValue_2.fields[0];
                break;
            }
            case 21: {
                matchResult = 1;
                w_1 = matchValue_2.fields[0];
                break;
            }
            default:
                matchResult = 4;
        }
        switch (matchResult) {
            case 0:
                return 1;
            case 1:
                return w_1;
            case 2:
                return (run_1 > 0) ? undefined : getPortWidth$0027(equals(port_1.PortType, PortType.Input) ? head(hostComponent.OutputPorts) : head(hostComponent.InputPorts))(pw_1)(run_1 + 1);
            case 3: {
                const c_1 = matchValue_2.fields[0];
                const indexInput = tryFindIndex((p) => equals(p.Id, port_1.Id), hostComponent.InputPorts);
                const indexOutput = tryFindIndex((p_1) => equals(p_1.Id, port_1.Id), hostComponent.OutputPorts);
                let matchResult_1, i, o;
                if (indexInput == null) {
                    if (indexOutput != null) {
                        matchResult_1 = 1;
                        o = indexOutput;
                    }
                    else {
                        matchResult_1 = 2;
                    }
                }
                else if (indexOutput == null) {
                    matchResult_1 = 0;
                    i = indexInput;
                }
                else {
                    matchResult_1 = 2;
                }
                switch (matchResult_1) {
                    case 0:
                        return item(i, c_1.InputLabels)[1];
                    case 1:
                        return item(o, c_1.OutputLabels)[1];
                    default:
                        return undefined;
                }
            }
            default:
                return undefined;
        }
    }));
    const getPortWidth = (port_2) => {
        if (portWidths.tag === 0) {
            return new FSharpResult$2(/* Ok */ 0, [getPortWidth$0027(port_2)(portWidths.fields[0])(0)]);
        }
        else {
            return new FSharpResult$2(/* Error */ 1, [portWidths.fields[0]]);
        }
    };
    const inferIOLabel = (port_3) => {
        let matchValue_4, _arg_2;
        let hostComponent_1;
        const _arg_1 = filter_1((c_2) => equals(port_3.HostId, c_2.Id), components);
        hostComponent_1 = (isEmpty(_arg_1) ? toFail(printf("what? Port HostId does not match any ComponentIds in model")) : (isEmpty(tail(_arg_1)) ? head(_arg_1) : toFail(printf("what? Port HostId matches multiple ComponentIds in model"))));
        const matchValue_5 = ((matchValue_4 = port_3.PortNumber, (matchValue_4 == null) ? ((_arg_2 = filter_1((cp) => equals(port_3.Id, cp.Id), collect((c_3) => append(c_3.InputPorts, c_3.OutputPorts), components)), !isEmpty(_arg_2) ? (isEmpty(tail(_arg_2)) ? head(_arg_2) : toFail(printf("what? connection port does not map to a component port"))) : toFail(printf("what? connection port does not map to a component port")))) : (port_3))).PortNumber;
        if (matchValue_5 != null) {
            if (port_3.PortType.tag === 1) {
                const pn_1 = matchValue_5 | 0;
                const matchValue_9 = portNames(hostComponent_1.Type);
                if (isEmpty(matchValue_9[1])) {
                    if (length(hostComponent_1.OutputPorts) > 1) {
                        return (hostComponent_1.Label + "_OUT") + int32ToString(pn_1);
                    }
                    else {
                        return hostComponent_1.Label + "_OUT";
                    }
                }
                else {
                    const lst_1 = matchValue_9[1];
                    if (pn_1 >= length(lst_1)) {
                        return toFail(printf("what? output PortNumber is greater than number of output port names on component"));
                    }
                    else {
                        length(hostComponent_1.InputPorts);
                        return item(pn_1, lst_1);
                    }
                }
            }
            else {
                const pn = matchValue_5 | 0;
                const matchValue_8 = portNames(hostComponent_1.Type);
                if (isEmpty(matchValue_8[0])) {
                    if (length(hostComponent_1.InputPorts) > 1) {
                        return (hostComponent_1.Label + "_IN") + int32ToString(pn);
                    }
                    else {
                        return hostComponent_1.Label + ".IN";
                    }
                }
                else {
                    const lst = matchValue_8[0];
                    if (pn >= length(lst)) {
                        return toFail(printf("what? input PortNumber is greater than number of input port names on component"));
                    }
                    else {
                        return item(pn, lst);
                    }
                }
            }
        }
        else {
            return toFail(printf("what? no PortNumber. A connection port was probably passed to inferIOLabel"));
        }
    };
    let tupledArg_5;
    let tupledArg_3;
    let tupledArg_2;
    const tupledArg_1 = [components, patternInput[1]];
    const comps = tupledArg_1[0];
    tupledArg_2 = [comps, fold((acc_1, con_1) => {
        let con;
        if (isEmpty(acc_1)) {
            return singleton(con_1);
        }
        else {
            const lst_3 = acc_1;
            if ((con = con_1, exists((c_4) => {
                if (equals(c_4.Source, con.Source) && !isPortInComponents(c_4.Target, comps)) {
                    return !isPortInComponents(con.Target, comps);
                }
                else {
                    return false;
                }
            }, lst_3))) {
                return lst_3;
            }
            else {
                return cons(con_1, lst_3);
            }
        }
    }, empty(), tupledArg_1[1])];
    const comps_1 = tupledArg_2[0];
    const conns_1 = tupledArg_2[1];
    tupledArg_3 = [comps_1, fold((acc_2, comp_2) => append(acc_2, append(map((p_4) => (new Connection(IdAllocator_newConnectionId(), dummyOutputPort, new Port(p_4.Id, undefined, p_4.PortType, p_4.HostId), singleton([0, 0, false]))), filter_1((p_3) => !isPortInConnections(p_3, conns_1), comp_2.InputPorts)), map((p_6) => (new Connection(IdAllocator_newConnectionId(), new Port(p_6.Id, undefined, p_6.PortType, p_6.HostId), dummyInputPort, singleton([0, 0, false]))), filter_1((p_5) => !isPortInConnections(p_5, conns_1), comp_2.OutputPorts)))), conns_1, comps_1)];
    const comps_2 = tupledArg_3[0];
    let result;
    const tupledArg_4 = mapFold((acc_4, con_2) => {
        if (!isPortInComponents(con_2.Source, comps_2) && !isPortInComponents(con_2.Target, comps_2)) {
            return [new FSharpResult$2(/* Error */ 1, [new SimulationError(new SimulationErrorType(/* WrongSelection */ 17, ["Selected logic includes a wire connected to no components."]), undefined, empty(), singleton(con_2.Id))]), acc_4];
        }
        else if (!isPortInComponents(con_2.Source, comps_2)) {
            const matchValue_10 = getPortWidth(con_2.Target);
            if (matchValue_10.tag === 1) {
                const e_3 = matchValue_10.fields[0];
                return [new FSharpResult$2(/* Ok */ 0, [con_2]), append(acc_4, singleton(new FSharpResult$2(/* Error */ 1, [new SimulationError(new SimulationErrorType(/* InferConnWidths */ 6, [e_3.Msg]), undefined, empty(), e_3.ConnectionsAffected)])))];
            }
            else if (matchValue_10.fields[0] == null) {
                return [new FSharpResult$2(/* Ok */ 0, [con_2]), append(acc_4, singleton(new FSharpResult$2(/* Error */ 1, [new SimulationError(new SimulationErrorType(/* InferConnWidths */ 6, ["Could not infer the width for an input into the selected logic."]), undefined, singleton(con_2.Target.HostId), empty())])))];
            }
            else {
                const pw_3 = matchValue_10.fields[0] | 0;
                const newId = IdAllocator_newComponentId();
                const newLabel = inferIOLabel(con_2.Target);
                const newPort = new Port(IdAllocator_newPortId(), 0, PortType.Output, newId);
                return [new FSharpResult$2(/* Ok */ 0, [new Connection(con_2.Id, new Port(newPort.Id, undefined, newPort.PortType, newPort.HostId), con_2.Target, con_2.Vertices)]), append(acc_4, singleton(new FSharpResult$2(/* Ok */ 0, [new Component(newId, new ComponentType(/* Input1 */ 0, [pw_3, undefined]), newLabel, empty(), singleton(newPort), 0, 0, 0, 0, undefined, undefined)])))];
            }
        }
        else if (!isPortInComponents(con_2.Target, comps_2)) {
            const matchValue_11 = getPortWidth(con_2.Source);
            if (matchValue_11.tag === 1) {
                const e_4 = matchValue_11.fields[0];
                return [new FSharpResult$2(/* Ok */ 0, [con_2]), append(acc_4, singleton(new FSharpResult$2(/* Error */ 1, [new SimulationError(new SimulationErrorType(/* InferConnWidths */ 6, [e_4.Msg]), undefined, empty(), e_4.ConnectionsAffected)])))];
            }
            else if (matchValue_11.fields[0] == null) {
                return [new FSharpResult$2(/* Ok */ 0, [con_2]), append(acc_4, singleton(new FSharpResult$2(/* Error */ 1, [new SimulationError(new SimulationErrorType(/* InferConnWidths */ 6, ["Could not infer the width for an output produced by the selected logic."]), undefined, singleton(con_2.Source.HostId), empty())])))];
            }
            else {
                const pw_4 = matchValue_11.fields[0] | 0;
                const newId_1 = IdAllocator_newComponentId();
                const newLabel_1 = inferIOLabel(con_2.Source);
                const newPort_1 = new Port(IdAllocator_newPortId(), 0, PortType.Input, newId_1);
                return [new FSharpResult$2(/* Ok */ 0, [new Connection(con_2.Id, con_2.Source, new Port(newPort_1.Id, undefined, newPort_1.PortType, newPort_1.HostId), con_2.Vertices)]), append(acc_4, singleton(new FSharpResult$2(/* Ok */ 0, [new Component(newId_1, new ComponentType(/* Output */ 1, [pw_4]), newLabel_1, singleton(newPort_1), empty(), 0, 0, 0, 0, undefined, undefined)])))];
            }
        }
        else {
            return [new FSharpResult$2(/* Ok */ 0, [con_2]), acc_4];
        }
    }, map((c_5) => (new FSharpResult$2(/* Ok */ 0, [c_5])), comps_2), tupledArg_3[1]);
    result = [tupledArg_4[1], tupledArg_4[0]];
    let uniqueNamesMap;
    const allLabels = collect((res) => {
        if (res.tag === 1) {
            return empty();
        }
        else {
            return singleton(res.fields[0].Label);
        }
    }, result[0]);
    const shortLabels = map((s) => {
        const index = s.indexOf(".") | 0;
        const len = s.length | 0;
        if (index === -1) {
            return s;
        }
        else {
            return s.slice(index + 1, (len - 1) + 1);
        }
    }, allLabels);
    uniqueNamesMap = ((length(shortLabels) === length(List_distinct(shortLabels, {
        Equals: (x_1, y_1) => (x_1 === y_1),
        GetHashCode: (x_1) => (stringHash(x_1) | 0),
    }))) ? ofList(zip(allLabels, shortLabels), {
        Compare: (x_2, y_2) => (comparePrimitives(x_2, y_2) | 0),
    }) : ofList(zip(allLabels, allLabels), {
        Compare: (x_3, y_3) => (comparePrimitives(x_3, y_3) | 0),
    }));
    tupledArg_5 = [map((res_1) => {
        if (res_1.tag === 1) {
            return new FSharpResult$2(/* Error */ 1, [res_1.fields[0]]);
        }
        else {
            const comp_4 = res_1.fields[0];
            return new FSharpResult$2(/* Ok */ 0, [new Component(comp_4.Id, comp_4.Type, FSharpMap__get_Item(uniqueNamesMap, comp_4.Label), comp_4.InputPorts, comp_4.OutputPorts, comp_4.X, comp_4.Y, comp_4.H, comp_4.W, comp_4.SymbolInfo, comp_4.SlotInfo)]);
        }
    }, result[0]), result[1]];
    const patternInput_1 = partitionResults(tupledArg_5[0]);
    const compErrors = patternInput_1[1];
    const patternInput_2 = partitionResults(tupledArg_5[1]);
    const connErrors = patternInput_2[1];
    if (!isEmpty(compErrors)) {
        return new FSharpResult$2(/* Error */ 1, [head(compErrors)]);
    }
    else if (!isEmpty(connErrors)) {
        return new FSharpResult$2(/* Error */ 1, [head(connErrors)]);
    }
    else {
        return new FSharpResult$2(/* Ok */ 0, [[patternInput_1[0], patternInput_2[0]]]);
    }
}

export class SelectionCache extends Record {
    constructor(UncorrectedCanvas, CorrectedCanvas, StoredResult) {
        super();
        this.UncorrectedCanvas = UncorrectedCanvas;
        this.CorrectedCanvas = CorrectedCanvas;
        this.StoredResult = StoredResult;
    }
}

export function SelectionCache_$reflection() {
    return record_type("TruthTableView.SelectionCache", [], SelectionCache, () => [["UncorrectedCanvas", tuple_type(list_type(Component_$reflection()), list_type(Connection_$reflection()))], ["CorrectedCanvas", tuple_type(list_type(Component_$reflection()), list_type(Connection_$reflection()))], ["StoredResult", union_type("Microsoft.FSharp.Core.FSharpResult`2", [SimulationData_$reflection(), SimulationError_$reflection()], FSharpResult$2, () => [[["ResultValue", SimulationData_$reflection()]], [["ErrorValue", SimulationError_$reflection()]]])]]);
}

export const emptySelCache = new SelectionCache([empty(), empty()], [empty(), empty()], new FSharpResult$2(/* Ok */ 0, [new SimulationData(simulationPlaceholder, empty_1({
    Compare: (x, y) => (comparePrimitives(x, y) | 0),
}), empty(), empty(), false, NumberBase.Hex, 0)]));

export let selCache = createAtom(emptySelCache);

/**
 * Make and return Simulation Data (or Simulation Error) for the model for selected components.
 * Identical functionality to SimulationView.makeSimData, but only considers selected components.
 * Includes memoization: if the selected components have not changed then the cached corrected
 * canvas and simulation are returned.
 */
export function makeSimDataSelected(model) {
    let tupledArg;
    const patternInput = DrawModelType_SheetT_Model__Model_get_GetSelectedCanvasState(model.Sheet);
    const selConnections = patternInput[1];
    const selComponents = patternInput[0];
    const wholeCanvas = DrawModelType_SheetT_Model__Model_GetCanvasState(model.Sheet);
    const matchValue = model.CurrentProj;
    if (matchValue != null) {
        if (isEmpty(selComponents)) {
            if (isEmpty(selConnections)) {
                return undefined;
            }
            else {
                return [new FSharpResult$2(/* Error */ 1, [new SimulationError(new SimulationErrorType(/* WrongSelection */ 17, ["Only connections selected. Please select a combination of connections and components."]), undefined, empty(), map((c) => c.Id, selConnections))]), [selComponents, selConnections]];
            }
        }
        else {
            const project = matchValue;
            const state = [selComponents, selConnections];
            if ((tupledArg = selCache().UncorrectedCanvas, stateIsEqual(state[0], state[1], tupledArg[0], tupledArg[1]))) {
                return [selCache().StoredResult, selCache().CorrectedCanvas];
            }
            else {
                const selLoadedComponents = filter_1((comp) => (comp.Name !== project.OpenFileName), project.LoadedComponents);
                const matchValue_2 = correctCanvasState(selComponents, selConnections, wholeCanvas[0], wholeCanvas[1]);
                if (matchValue_2.tag === 0) {
                    const correctConns = matchValue_2.fields[0][1];
                    const correctComps = matchValue_2.fields[0][0];
                    const matchValue_3 = analyseState(correctComps, correctConns, selLoadedComponents);
                    if (matchValue_3[0] == null) {
                        const sim = startCircuitSimulationFData(2, project.OpenFileName, correctComps, correctConns, selLoadedComponents);
                        const newState = [correctComps, correctConns];
                        selCache(new SelectionCache(state, newState, sim));
                        return [sim, newState];
                    }
                    else {
                        return [new FSharpResult$2(/* Error */ 1, [matchValue_3[0]]), [correctComps, correctConns]];
                    }
                }
                else {
                    const e = matchValue_2.fields[0];
                    selCache(new SelectionCache(state, [selComponents, selConnections], new FSharpResult$2(/* Error */ 1, [e])));
                    return [new FSharpResult$2(/* Error */ 1, [e]), [selComponents, selConnections]];
                }
            }
        }
    }
    else {
        return undefined;
    }
}

export function makeSortingArrows(io, sortInfo, dispatch) {
    let cio_1, cio;
    const patternInput = (sortInfo != null) ? ((sortInfo[1].tag === 1) ? ((cio_1 = sortInfo[0], [false, equals(cio_1, io)])) : ((cio = sortInfo[0], [equals(cio, io), false]))) : [false, false];
    const upArrow = button(toList_1(delay(() => append_1(singleton_1(new Option(/* Props */ 17, [singleton(sortArrowStyle)])), delay(() => append_1(patternInput[0] ? singleton_1(new Option(/* Color */ 0, [Color_IColor.IsInfo])) : empty_2(), delay(() => singleton_1(new Option(/* OnClick */ 18, [(_arg) => {
        dispatch(new TTMsg(/* SetTTSortType */ 16, [[io, SortType.Ascending]]));
    }])))))))), singleton("▲"));
    const downArrow = button(toList_1(delay(() => append_1(singleton_1(new Option(/* Props */ 17, [singleton(sortArrowStyle)])), delay(() => append_1(patternInput[1] ? singleton_1(new Option(/* Color */ 0, [Color_IColor.IsInfo])) : empty_2(), delay(() => singleton_1(new Option(/* OnClick */ 18, [(_arg_1) => {
        dispatch(new TTMsg(/* SetTTSortType */ 16, [[io, SortType.Descending]]));
    }])))))))), singleton("▼"));
    return react.createElement("div", {}, upArrow, downArrow);
}

export function makeColumnMoveArrows(io, headingEl, dispatch) {
    const children = [makeElementLine(singleton(button(ofArray([new Option(/* Props */ 17, [singleton(colMoveArrowStyle)]), new Option(/* OnClick */ 18, [(_arg) => {
        dispatch(new TTMsg(/* MoveColumn */ 17, [[io, MoveDirection.MLeft]]));
    }])]), singleton("<"))), singleton(button(ofArray([new Option(/* Props */ 17, [singleton(colMoveArrowStyle)]), new Option(/* OnClick */ 18, [(_arg_1) => {
        dispatch(new TTMsg(/* MoveColumn */ 17, [[io, MoveDirection.MRight]]));
    }])]), singleton(">")))), headingEl];
    return react.createElement("div", {}, ...children);
}

function makeMenuGroup(openDefault, title, menuList) {
    const children_2 = [react.createElement("summary", keyValueList([menuLabelStyle], 1), title), list_17(empty(), menuList)];
    return react.createElement("details", {
        open: openDefault,
    }, ...children_2);
}

export function viewOutputHider(table, hidden, dispatch) {
    if (FSharpMap__get_IsEmpty(table.FilteredMap)) {
        return react.createElement("div", {}, "No Rows in Truth Table");
    }
    else {
        let preamble;
        const children_2 = ["Hide or Un-hide Output or Viewer columns in the Truth Table.", react.createElement("br", {}), react.createElement("br", {})];
        preamble = react.createElement("div", {}, ...children_2);
        const toggleRows = map((cell) => {
            const io = cell.IO;
            const toggle = makeOnOffToggle(true, !contains(io, hidden, {
                Equals: equals,
                GetHashCode: (x) => (safeHash(x) | 0),
            }), (_arg) => {
                dispatch(new TTMsg(/* ToggleHideTTColumn */ 13, [io]));
            }, "Visible", "Hidden");
            return makeElementLine(ofArray([CellIO__get_getLabel(io), toggle]), empty());
        }, head(toList(table.TableMap))[1]);
        return react.createElement("div", {}, ...cons(preamble, toggleRows));
    }
}

export function viewCellAsHeading(dispatch, sortInfo, styleInfo, model, cell) {
    let matchValue_2, copyOfStruct_1, inputCount_1, cellIndex_1, draggedCol_1, r;
    const addMoveArrows = (el) => makeColumnMoveArrows(cell.IO, el, dispatch);
    equals(model.TTConfig.DraggedColumn, cell.IO);
    const isHovered = equals(model.TTConfig.HoveredColumn, cell.IO);
    let isOutputColumn;
    const matchValue = model.CurrentTruthTable;
    let matchResult, table;
    if (matchValue != null) {
        const copyOfStruct = matchValue;
        if (copyOfStruct.tag === 0) {
            matchResult = 0;
            table = copyOfStruct.fields[0];
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0: {
            const inputCount = length(table.TableSimData.Inputs) | 0;
            const cellIndex = defaultArg(tryFindIndex((y) => equals(cell.IO, y), ofArray(model.TTConfig.IOOrder)), -1) | 0;
            isOutputColumn = ((cellIndex >= inputCount) && (cellIndex < (inputCount + length(table.TableSimData.Outputs))));
            break;
        }
        default:
            isOutputColumn = false;
    }
    let canAcceptDrop;
    const matchValue_1 = model.TTConfig.DraggedColumn;
    if (matchValue_1 != null) {
        const draggedColumn = matchValue_1;
        canAcceptDrop = (((matchValue_2 = model.CurrentTruthTable, (matchValue_2 != null) && ((copyOfStruct_1 = matchValue_2, (copyOfStruct_1.tag === 0) && ((inputCount_1 = (length(copyOfStruct_1.fields[0].TableSimData.Inputs) | 0), (cellIndex_1 = (defaultArg(tryFindIndex((y_1) => equals(draggedColumn, y_1), ofArray(model.TTConfig.IOOrder)), -1) | 0), (cellIndex_1 >= inputCount_1) && (cellIndex_1 < (inputCount_1 + length(copyOfStruct_1.fields[0].TableSimData.Outputs)))))))))) === isOutputColumn);
    }
    else {
        canAcceptDrop = true;
    }
    let dragStyle;
    const matchValue_3 = model.TTConfig.DraggedColumn;
    dragStyle = ((matchValue_3 == null) ? singleton(new CSSProp(/* Cursor */ 123, ["grab"])) : (equals(matchValue_3, cell.IO) ? ((draggedCol_1 = matchValue_3, ofArray([new CSSProp(/* Cursor */ 123, ["grabbing"]), new CSSProp(/* Opacity */ 261, [0.5])]))) : (isHovered ? (canAcceptDrop ? singleton(new CSSProp(/* BorderLeft */ 65, ["3px solid #3273dc"])) : ofArray([new CSSProp(/* BorderLeft */ 65, ["3px solid #dc3545"]), new CSSProp(/* Cursor */ 123, ["not-allowed"])])) : singleton(new CSSProp(/* Cursor */ 123, ["grab"])))));
    const outputStyle = isOutputColumn ? ofArray([new CSSProp(/* BackgroundColor */ 21, ["#f0f8ff"]), new CSSProp(/* FontStyle */ 156, ["italic"])]) : empty();
    let cellStyle;
    const matchValue_4 = tryFind(cell.IO, styleInfo);
    cellStyle = ((matchValue_4 != null) ? ["style", keyValueList(cons(new CSSProp(/* FontWeight */ 165, ["bold"]), append(matchValue_4, append(singleton(new CSSProp(/* BorderBottom */ 42, ["3px solid black"])), append(dragStyle, outputStyle)))), 1)] : toFail(printf("what? IO %A not found in Grid Styles"))(cell.IO));
    const matchValue_5 = cell.IO;
    if (matchValue_5.tag === 1) {
        const fullName = matchValue_5.fields[0][1];
        const children_2 = [addMoveArrows(makeElementLine(singleton((r = matchValue_5.fields[0][0], (fullName !== "") ? addToolTipTop(fullName, r) : r)), singleton(makeSortingArrows(cell.IO, sortInfo, dispatch))))];
        return react.createElement("div", keyValueList([cellStyle, new HTMLAttr(/* Draggable */ 81, [true]), new DOMAttr(/* OnDragStart */ 49, [(ev_6) => {
            ev_6.dataTransfer.effectAllowed = "move";
            ev_6.dataTransfer.dropEffect = "move";
            dispatch(new TTMsg(/* StartDraggingColumn */ 29, [cell.IO]));
        }]), new DOMAttr(/* OnDragEnd */ 44, [(_arg_1) => {
            dispatch(TTMsg.EndDraggingColumn);
        }]), new DOMAttr(/* OnDragEnter */ 45, [(ev_7) => {
            ev_7.preventDefault();
            ev_7.dataTransfer.dropEffect = "move";
            dispatch(new TTMsg(/* DragColumnEnter */ 30, [cell.IO]));
        }]), new DOMAttr(/* OnDragOver */ 48, [(ev_8) => {
            ev_8.preventDefault();
            ev_8.dataTransfer.dropEffect = "move";
        }]), new DOMAttr(/* OnDrop */ 50, [(ev_9) => {
            ev_9.preventDefault();
            dispatch(TTMsg.EndDraggingColumn);
        }]), new DOMAttr(/* OnDragLeave */ 47, [(ev_10) => {
            const tableEl_1 = document.getElementById("ttGridContainer");
            if (!equals(tableEl_1, defaultOf())) {
                const rect_1 = tableEl_1.getBoundingClientRect();
                if ((((ev_10.clientX < rect_1.left) ? true : (ev_10.clientX > rect_1.right)) ? true : (ev_10.clientY < rect_1.top)) ? true : (ev_10.clientY > rect_1.bottom)) {
                    dispatch(TTMsg.CancelDraggingColumn);
                }
            }
        }])], 1), ...children_2);
    }
    else {
        const children = [addMoveArrows(makeElementLine(singleton(toString(matchValue_5.fields[0][1])), singleton(makeSortingArrows(cell.IO, sortInfo, dispatch))))];
        return react.createElement("div", keyValueList([cellStyle, new HTMLAttr(/* Draggable */ 81, [true]), new DOMAttr(/* OnDragStart */ 49, [(ev) => {
            ev.dataTransfer.effectAllowed = "move";
            ev.dataTransfer.dropEffect = "move";
            dispatch(new TTMsg(/* StartDraggingColumn */ 29, [cell.IO]));
        }]), new DOMAttr(/* OnDragEnd */ 44, [(_arg) => {
            dispatch(TTMsg.EndDraggingColumn);
        }]), new DOMAttr(/* OnDragEnter */ 45, [(ev_1) => {
            ev_1.preventDefault();
            ev_1.dataTransfer.dropEffect = "move";
            dispatch(new TTMsg(/* DragColumnEnter */ 30, [cell.IO]));
        }]), new DOMAttr(/* OnDragOver */ 48, [(ev_2) => {
            ev_2.preventDefault();
            ev_2.dataTransfer.dropEffect = "move";
        }]), new DOMAttr(/* OnDrop */ 50, [(ev_3) => {
            ev_3.preventDefault();
            dispatch(TTMsg.EndDraggingColumn);
        }]), new DOMAttr(/* OnDragLeave */ 47, [(ev_4) => {
            const tableEl = document.getElementById("ttGridContainer");
            if (!equals(tableEl, defaultOf())) {
                const rect = tableEl.getBoundingClientRect();
                if ((((ev_4.clientX < rect.left) ? true : (ev_4.clientX > rect.right)) ? true : (ev_4.clientY < rect.top)) ? true : (ev_4.clientY > rect.bottom)) {
                    dispatch(TTMsg.CancelDraggingColumn);
                }
            }
        }]), new DOMAttr(/* OnMouseUp */ 57, [(ev_5) => {
            ev_5.stopPropagation();
            if (model.TTConfig.DraggedColumn != null) {
                dispatch(TTMsg.EndDraggingColumn);
            }
        }])], 1), ...children);
    }
}

export function viewRowAsData(numBase, styleInfo, model, i, row) {
    return map((cell) => {
        let isOutputColumn;
        const matchValue = model.CurrentTruthTable;
        let matchResult, table;
        if (matchValue != null) {
            const copyOfStruct = matchValue;
            if (copyOfStruct.tag === 0) {
                matchResult = 0;
                table = copyOfStruct.fields[0];
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0: {
                const inputCount = length(table.TableSimData.Inputs) | 0;
                const cellIndex = defaultArg(tryFindIndex((y) => equals(cell.IO, y), ofArray(model.TTConfig.IOOrder)), -1) | 0;
                isOutputColumn = ((cellIndex >= inputCount) && (cellIndex < (inputCount + length(table.TableSimData.Outputs))));
                break;
            }
            default:
                isOutputColumn = false;
        }
        const outputStyle = isOutputColumn ? singleton(new CSSProp(/* BackgroundColor */ 21, [((i % 2) === 1) ? "#e8f4fd" : "#f0f8ff"])) : empty();
        let cellStyle;
        const matchValue_1 = tryFind(cell.IO, styleInfo);
        const matchValue_2 = (i % 2) | 0;
        let matchResult_1, s_1, s_2;
        if (matchValue_1 != null) {
            if (matchValue_2 === 1) {
                if (!isOutputColumn) {
                    matchResult_1 = 1;
                    s_1 = matchValue_1;
                }
                else {
                    matchResult_1 = 2;
                    s_2 = matchValue_1;
                }
            }
            else {
                matchResult_1 = 2;
                s_2 = matchValue_1;
            }
        }
        else {
            matchResult_1 = 0;
        }
        switch (matchResult_1) {
            case 0: {
                cellStyle = toFail(printf("what? IO %A not found in Grid Styles"))(cell.IO);
                break;
            }
            case 1: {
                cellStyle = ["style", keyValueList(append(cons(new CSSProp(/* BackgroundColor */ 21, ["whitesmoke"]), s_1), outputStyle), 1)];
                break;
            }
            default:
                cellStyle = ["style", keyValueList(append(s_2, outputStyle), 1)];
        }
        const matchValue_4 = cell.Data;
        switch (matchValue_4.tag) {
            case 1: {
                const katexString = expToKatex(matchValue_4.fields[0]);
                const props_4 = [cellStyle, new DOMAttr(/* DangerouslySetInnerHTML */ 0, [new DangerousHtml(katex.renderToString(katexString, {
                    throwOnError: false,
                }))])];
                return react.createElement("div", keyValueList(props_4, 1));
            }
            case 2:
                return react.createElement("div", keyValueList([cellStyle], 1), "X");
            default:
                if (!isEmpty(matchValue_4.fields[0])) {
                    if (isEmpty(tail(matchValue_4.fields[0]))) {
                        const children = [bitToString(head(matchValue_4.fields[0]))];
                        return react.createElement("div", keyValueList([cellStyle], 1), ...children);
                    }
                    else {
                        const value_1 = viewFilledNum(length(matchValue_4.fields[0]), numBase)(convertWireDataToInt(matchValue_4.fields[0]));
                        return react.createElement("div", keyValueList([cellStyle], 1), value_1);
                    }
                }
                else {
                    return toFail(printf("what? Empty WireData in TruthTable"));
                }
        }
    }, row);
}

export function viewTruthTableError(simError) {
    let error;
    const matchValue = simError.InDependency;
    if (matchValue != null) {
        const children_2 = [("Error found in dependency \"" + matchValue) + "\":", react.createElement("br", {}), errMsg(simError.ErrType), react.createElement("br", {}), "Please fix the error in the dependency and retry."];
        error = react.createElement("div", {}, ...children_2);
    }
    else {
        const children = [errMsg(simError.ErrType), react.createElement("br", {}), "Please fix the error and retry."];
        error = react.createElement("div", {}, ...children);
    }
    const children_4 = [h5(singleton(new Option_1(/* Props */ 9, [singleton(["style", {
        marginTop: "15px",
    }])])))(singleton("Errors")), error];
    return react.createElement("div", {}, ...children_4);
}

export function viewTruthTableData(table, model, dispatch) {
    const matchValue = model.TTConfig.GridCache;
    if (matchValue == null) {
        const tLst = table.SortedListRep;
        const styleInfo = model.TTConfig.GridStyles;
        if (isEmpty(tLst)) {
            return react.createElement("div", {}, "No Rows in Truth Table");
        }
        else {
            const all = append(map((cell) => viewCellAsHeading(dispatch, model.TTConfig.SortType, styleInfo, model, cell), head(tLst)), concat(mapIndexed((i, row) => viewRowAsData(table.TableSimData.NumberBase, styleInfo, model, i, row), tLst)));
            let grid_1;
            const props_2 = [new HTMLAttr(/* Id */ 99, ["ttGridContainer"]), ttGridContainerStyle(model), new DOMAttr(/* OnMouseUp */ 57, [(_arg) => {
                if (model.TTConfig.DraggedColumn != null) {
                    dispatch(TTMsg.EndDraggingColumn);
                }
            }]), new DOMAttr(/* OnMouseLeave */ 53, [(_arg_1) => {
                if (model.TTConfig.DraggedColumn != null) {
                    dispatch(TTMsg.EndDraggingColumn);
                }
            }])];
            grid_1 = react.createElement("div", keyValueList(props_2, 1), ...all);
            dispatch(new TTMsg(/* SetTTGridCache */ 21, [grid_1]));
            return grid_1;
        }
    }
    else {
        return matchValue;
    }
}

export function restartTruthTable(canvasState_, canvasState__1, model, dispatch, _arg) {
    const canvasState = [canvasState_, canvasState__1];
    const wholeSimRes = simulateModel(true, false, undefined, 2, canvasState[0], canvasState[1], model);
    const copyOfStruct = wholeSimRes[0];
    if (copyOfStruct.tag === 0) {
    }
    else {
        setSimErrorFeedback(copyOfStruct.fields[0], model, dispatch);
    }
    dispatch(new Msg(/* TruthTableMsg */ 32, [new TTMsg(/* GenerateTruthTable */ 0, [wholeSimRes])]));
}

class NoTable extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["HasState", "HasWideBus"];
    }
}

function NoTable_$reflection() {
    return union_type("TruthTableView.NoTable", [], NoTable, () => [[["Item", list_type(int32_type)]], [["Item", list_type(int32_type)]]]);
}

function clockedComponentsOf(graph) {
    return choose((tupledArg) => {
        let matchValue, option_1;
        const comp = tupledArg[1];
        if ((matchValue = comp.Type, (matchValue.tag === 26) ? defaultArg((option_1 = comp.CustomSimulationGraph, (option_1 != null) ? hasSynchronousComponents(option_1) : undefined), true) : couldBeSynchronousComponent(matchValue))) {
            return tupledArg[0];
        }
        else {
            return undefined;
        }
    }, SimGraph_toList(graph));
}

function wideBusComponentsOf(fs) {
    const wide = filter_1((fc) => fc.Outputs.some((out) => (out.Width > Constants_maxTruthTableBusWidth)), ofArray(fs.FCompsByIndex));
    return [map((fc_2) => fc_2.cId, filter_1((fc_1) => equals(fc_1.AccessPath, empty()), wide)), !isEmpty(wide)];
}

function noTableBecause(sd) {
    if (sd.IsSynchronous) {
        return new NoTable(/* HasState */ 0, [clockedComponentsOf(sd.Graph)]);
    }
    else {
        const matchValue = wideBusComponentsOf(sd.FastSim);
        if (matchValue[1]) {
            return new NoTable(/* HasWideBus */ 1, [matchValue[0]]);
        }
        else {
            return undefined;
        }
    }
}

function explainNoTable(reason, dispatch) {
    const patternInput = (reason.tag === 1) ? [reason.fields[0], TruthTable_busTooWide(Constants_maxTruthTableBusWidth)] : [reason.fields[0], TruthTable_notCombinational];
    dispatch(new Msg(/* SetHighlighted */ 35, [patternInput[0], empty()]));
    dispatch(new Msg(/* SetPropertiesNotification */ 83, [errorPropsNotification(patternInput[1])]));
}

export function viewTruthTable(canvasState_, canvasState__1, model, dispatch) {
    let props_38, props_40, s_12, props_46, children_18;
    const canvasState = [canvasState_, canvasState__1];
    const ttDispatch = (ttMsg) => {
        dispatch(new Msg(/* TruthTableMsg */ 32, [ttMsg]));
    };
    updateMergeSplitWireLabels(model, dispatch);
    const matchValue = model.CurrentTruthTable;
    if (matchValue != null) {
        const tableopt = matchValue;
        let body;
        if (tableopt.tag === 0) {
            const table = tableopt.fields[0];
            const truncation = notification(ofArray([new Option_2(/* Color */ 0, [Color_IColor.IsWarning]), Option_2.IsLight, new Option_2(/* Props */ 3, [singleton(["style", {
                whiteSpace: "nowrap",
                overflowX: "hidden",
            }])])]), singleton("You can use input constraints, or algebraic variables, to reduce the number of rows."));
            const props_20 = [["style", {
                maxWidth: rightSectionWidth(model),
                maxHeight: "calc(100vh - 300px)",
                overflowX: "auto",
                overflowY: "auto",
                paddingRight: "10px",
            }]];
            const children_4 = toList_1(delay(() => append_1(table.IsTruncated ? singleton_1(truncation) : empty_2(), delay(() => append_1(singleton_1(viewReductions(table, model, dispatch)), delay(() => append_1(singleton_1(react.createElement("br", {})), delay(() => singleton_1(viewTruthTableData(table, model, ttDispatch))))))))));
            body = react.createElement("div", keyValueList(props_20, 1), ...children_4);
        }
        else {
            body = viewSimulationError(canvasState[0], canvasState[1], tableopt.fields[0], model, SimSubTab.TruthTable, dispatch);
        }
        let constraints;
        if (tableopt.tag === 0) {
            const children_8 = [viewConstraints(model, dispatch)];
            constraints = react.createElement("div", {}, ...children_8);
        }
        else {
            constraints = react.createElement("div", {});
        }
        let hidden;
        if (tableopt.tag === 0) {
            const children_12 = [viewOutputHider(tableopt.fields[0], model.TTConfig.HiddenColumns, ttDispatch)];
            hidden = react.createElement("div", {}, ...children_12);
        }
        else {
            hidden = react.createElement("div", {});
        }
        const menu = menu_1(empty(), ofArray([makeMenuGroup(false, "Filter", ofArray([constraints, react.createElement("br", {}), react.createElement("hr", {})])), makeMenuGroup(false, "Hide/Un-hide Columns", ofArray([hidden, react.createElement("br", {}), react.createElement("hr", {})]))]));
        const props_48 = [["style", {
            padding: "10px",
        }]];
        const children_20 = [(props_38 = [["style", {
            float: "left",
            fontSize: "20px",
            fontWeight: "Bold",
        }]], react.createElement("div", keyValueList(props_38, 1), "Truth Table")), button(ofArray([new Option(/* Color */ 0, [Color_IColor.IsDanger]), new Option(/* OnClick */ 18, [(_arg_6) => {
            dispatch(new Msg(/* Sheet */ 3, [DrawModelType_SheetT_Msg.ResetSelection]));
            dispatch(Msg.ClosePropertiesNotification);
            ttDispatch(TTMsg.CloseTruthTable);
        }]), new Option(/* Props */ 17, [singleton(["style", {
            float: "right",
        }])])]), singleton("Close Truth Table")), (props_40 = [["style", {
            clear: "both",
        }]], react.createElement("div", keyValueList(props_40, 1))), (s_12 = "The Truth Table generator uses the diagram as it was at the moment of\r\n                 pressing the \"Generate Truth Table\" button.", s_12), menu, (props_46 = [["style", {
            width: "100%",
        }]], (children_18 = [body, react.createElement("br", {}), react.createElement("hr", {})], react.createElement("div", keyValueList(props_46, 1), ...children_18)))];
        return react.createElement("div", keyValueList(props_48, 1), ...children_20);
    }
    else {
        const wholeSimRes = simulateModel(true, false, undefined, 2, canvasState[0], canvasState[1], model);
        let wholeButton;
        const copyOfStruct = wholeSimRes[0];
        if (copyOfStruct.tag === 0) {
            const matchValue_1 = noTableBecause(copyOfStruct.fields[0]);
            if (matchValue_1 != null) {
                const reason = matchValue_1;
                wholeButton = button(ofArray([new Option(/* Color */ 0, [Color_IColor.IsWarning]), Option.IsLight, new Option(/* OnClick */ 18, [(_arg_2) => {
                    explainNoTable(reason, dispatch);
                }])]), singleton("Why is there no table?"));
            }
            else {
                wholeButton = button(ofArray([new Option(/* Color */ 0, [Color_IColor.IsSuccess]), new Option(/* OnClick */ 18, [(_arg_1) => {
                    ttDispatch(new TTMsg(/* GenerateTruthTable */ 0, [wholeSimRes]));
                }])]), singleton("Generate Truth Table"));
            }
        }
        else {
            wholeButton = button(ofArray([new Option(/* Color */ 0, [Color_IColor.IsWarning]), new Option(/* OnClick */ 18, [(_arg) => {
                setSimErrorFeedback(copyOfStruct.fields[0], model, dispatch);
                ttDispatch(new TTMsg(/* GenerateTruthTable */ 0, [wholeSimRes]));
            }])]), singleton("See Problems"));
        }
        const selSimRes = makeSimDataSelected(model);
        let selButton;
        if (selSimRes != null) {
            const copyOfStruct_1 = selSimRes[0];
            if (copyOfStruct_1.tag === 0) {
                const matchValue_2 = noTableBecause(copyOfStruct_1.fields[0]);
                if (matchValue_2 != null) {
                    const reason_1 = matchValue_2;
                    selButton = button(ofArray([new Option(/* Color */ 0, [Color_IColor.IsWarning]), Option.IsLight, new Option(/* OnClick */ 18, [(_arg_5) => {
                        explainNoTable(reason_1, dispatch);
                    }])]), singleton("Why is there no table?"));
                }
                else {
                    selButton = button(ofArray([new Option(/* Color */ 0, [Color_IColor.IsSuccess]), new Option(/* OnClick */ 18, [(_arg_4) => {
                        ttDispatch(new TTMsg(/* GenerateTruthTable */ 0, [selSimRes]));
                    }])]), singleton("Generate Truth Table"));
                }
            }
            else {
                selButton = button(ofArray([new Option(/* Color */ 0, [Color_IColor.IsWarning]), new Option(/* OnClick */ 18, [(_arg_3) => {
                    setSimErrorFeedback(copyOfStruct_1.fields[0], model, dispatch);
                    ttDispatch(new TTMsg(/* GenerateTruthTable */ 0, [selSimRes]));
                }])]), singleton("See Problems"));
            }
        }
        else {
            selButton = react.createElement("div", {});
        }
        const props_16 = [["style", {
            padding: "10px",
        }]];
        const children_2 = ["Generate Truth Tables for combinational logic using this tab.", react.createElement("br", {}), react.createElement("hr", {}), h5(empty())(singleton("Truth Table for whole sheet")), react.createElement("br", {}), wholeButton, react.createElement("hr", {}), h5(empty())(singleton("Truth Table for selected logic")), react.createElement("br", {}), react.createElement("br", {}), selButton, react.createElement("hr", {})];
        return react.createElement("div", keyValueList(props_16, 1), ...children_2);
    }
}

